<ion-card class="InteractiveMap">
  <ion-card-content>
    <div
      id="google-map"
      class="InteractiveMap__Map"
      width="100%"
      height="75vh"
    ></div>
  </ion-card-content>
</ion-card>
